import { Pressable, View } from 'react-native'
import { styled } from '~/core/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      minWidth: theme.sizingHuge,

      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',

      gap: theme.spacingInlineTwopulse,

      borderRadius: theme.borderRadiusPill,
      borderWidth: theme.borderWidthQuarterpulse,
      borderColor: theme.colorActionBorderNeutralSecondaryEnabled,
      backgroundColor: theme.colorActionFillNeutralSecondaryEnabled,
      paddingHorizontal: theme.paddingInsetTwopulse,
    },
    variants: {
      size: {
        md: {
          height: theme.sizingMedium,
        },
        ml: {
          height: theme.sizingMediumlarge,
          minWidth: theme.sizingMediumlarge,
        },
      },
      selected: {
        true: {
          borderColor: theme.colorActionBorderNeutralSecondaryActivated,
          backgroundColor: theme.colorActionFillNeutralSecondaryActivated,
          borderWidth: theme.borderWidthHalfpulse,
        },
      },
      checked: {
        true: {
          borderColor: theme.colorActionBorderNeutralSecondaryActivated,
          backgroundColor: theme.colorActionFillNeutralSecondaryActivated,
          borderWidth: theme.borderWidthHalfpulse,
        },
      },
      disabled: {
        true: {
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
          backgroundColor: theme.colorBrowsingFillOnbrandDisabled,
          color: theme.colorTextNeutralDisabled,
          borderWidth: theme.borderWidthQuarterpulse,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          isPressed: true,
          checked: true,
        },
        css: {
          backgroundColor: theme.colorActionFillNeutralSecondaryPressed,
          borderColor: theme.colorActionBorderNeutralSecondaryPressed,
          borderWidth: theme.borderWidthQuarterpulse,
        },
      },
      {
        variants: {
          isPressed: true,
          checked: false,
        },
        css: {
          backgroundColor: theme.colorActionFillNeutralSecondaryPressed,
          borderColor: theme.colorActionFillNeutralSecondaryPressed,
        },
      },
      {
        variants: {
          isPressed: true,
          selected: true,
        },
        css: {
          backgroundColor: theme.colorActionFillNeutralSecondaryPressed,
          borderColor: theme.colorActionBorderNeutralSecondaryPressed,
          borderWidth: theme.borderWidthQuarterpulse,
        },
      },
      {
        variants: {
          isPressed: true,
          selected: false,
        },
        css: {
          backgroundColor: theme.colorActionFillNeutralSecondaryPressed,
          borderColor: theme.colorActionFillNeutralSecondaryPressed,
        },
      },
      {
        variants: {
          checked: true,
          selected: true,
          disabled: true,
          size: 'md',
        },
        css: {
          borderColor: theme.colorBrowsingBorderOnbrandDisabled,
        },
      },
    ],
  }
})

export const Content = styled(View, theme => {
  return {
    base: {
      flexShrink: 1,
      flexDirection: 'row',
      alignItems: 'center',

      gap: theme.spacingInlineTwopulse,
    },
  }
})
